interface IHasRemainingFavoriteLorebooksProps {
  likedLorebookIds: string[];
  pendingRemovedLorebookIds: Set<string>;
}

const hasRemainingFavoriteLorebooks = ({ likedLorebookIds, pendingRemovedLorebookIds }: IHasRemainingFavoriteLorebooksProps): boolean =>
  likedLorebookIds.some((lorebookId) => !pendingRemovedLorebookIds.has(lorebookId));

export default hasRemainingFavoriteLorebooks;
